// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/federlaenge/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const federlaengeDE: PageEntry = {
  id: "post.federlaenge",
  locale: "de",
  slug: "federlaenge",
  seo: {
    title: "Glossar: Federlänge einfach erklärt | Dietz GmbH",
    description: "Die Federlänge bezieht sich auf die freie, unbelastete Länge einer Feder, wenn sie sich in ihrem natürlichen Zustand befindet. Diese Länge ist ein wichtiger Parameter bei der Besti",
  },
  type: "post",
  h1: "Glossar: Federlänge einfach erklärt",
  intro: "Die Federlänge bezieht sich auf die freie, unbelastete Länge einer Feder, wenn sie sich in ihrem natürlichen Zustand befindet. Diese Länge ist ein wichtiger Parameter bei der Bestimmung der Federcharakteristik und ihrer Einsatzmöglichkeiten. Bei gestreckten oder komprimierten Federn wird die tatsächliche Länge im Vergleich zur freien Länge verändert, was die Federkraft beeinflusst. Die Federlänge ist ein entscheidender Faktor bei der Auslegung von Feder-Systemen, da sie direkt mit der Federkonstante und anderen mechanischen Eigenschaften zusammenhängt.",
  blocks: [

  ],
};
